
import React, {useMemo, useState, useEffect} from 'react';

import { useAuth } from '../../hooks/useAuth';
import logo from '../../../dist/assets/images/nia_logo.png';


import {
    Container,
    Profile,
    Welcome,
    LogImg
} from './styles';

const MainHeader: React.FC = () => {

    const { user } = useAuth();
    const [ userName, setUserName] = useState<string>('');
    useEffect(() => {
        setUserName(user.name)
    }, [])
    
    return (
        <Container>

            <Profile>
                <Welcome>Olá, {userName}</Welcome>
                <LogImg src={logo} alt="Nia" />
            </Profile>

        </Container>
    );
}

export default MainHeader;
